module.exports = __webpack_public_path__ + "static/delete_user_confirmation-ef7add19e27d1eff4044aadd4970818b.png";